import { render, staticRenderFns } from "./SocialForm.vue?vue&type=template&id=302a4525&scoped=true&"
import script from "./SocialForm.vue?vue&type=script&lang=js&"
export * from "./SocialForm.vue?vue&type=script&lang=js&"
import style0 from "./SocialForm.vue?vue&type=style&index=0&id=302a4525&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302a4525",
  null
  
)

export default component.exports